import { React, useState, useEffect } from 'react';
import { FxmsData } from '../datas/FxData';
import { AttrListEdit } from "./../datas/OpClass";

export function FxTextBoxConfig(fxUiGrp, fxUiGrpItem) {

  const setList = new AttrListEdit("setting");
  setList.makeAttrText(10, "text", "문구", 300);
  setList.makeAttrText(20, "fontSize", "폰트크기 pt입력", 100);
  setList.makeAttrText(21, "fontWeight", "폰트굵기", 100);
  setList.makeAttrText(30, "color", "글자색", 100);
  setList.makeAttrText(31, "backgroundColor", "배경색", 100);
  setList.makeAttrButton(40, "iconApply", "적용", 100, null, function (data) {
    FxmsData.updateUi(fxUiGrp, fxUiGrpItem, data);
  });

  return setList;
}


export const FxTextBox = (props) => {
  const { id, fxUiGrp, fxUiGrpItem } = props;
  const [style, setStyle] = useState({});


  useEffect(() => {

    console.log("*** FxTextBox ***", props);

    const s = { text: '텍스트박스', color: 'black', fontSize: '12pt', backgroundColor: 'white' };
    const obj = fxUiGrpItem && fxUiGrpItem.attrObj ? fxUiGrpItem.attrObj : null;
    if (obj) {
      s.text = obj.text ? obj.text : '텍스트박스';
      s.color = obj.color ? obj.color : 'red';
      s.fontSize = (obj.fontSize ? obj.fontSize : '12') + 'pt';
      s.backgroundColor = obj.backgroundColor ? obj.backgroundColor : 'white';
      s.fontWeight = obj.fontWeight ? obj.fontWeight : 'normal';
    }
    setStyle(s);

  }, []);

  return (
    <div className='TextBoxButton' style={style}>
      {style.text}
    </div>
  )
}
